'use strict';

export default {
    fitbit: 'https://static.chewba.info/images/fitbit-app-icon.svg',
};
